export const TOKEN_STORAGE_KEY = 'JWT_TOKEN';

/**
 * Jeton d'une prise d'identité : conservé dans le sessionStorage de l'onglet
 * ouvert par le backoffice, il ne remplace jamais la session de l'utilisateur
 * réel (localStorage ou sessionStorage sous TOKEN_STORAGE_KEY).
 */
export const IMPERSONATION_TOKEN_STORAGE_KEY = 'JWT_IMPERSONATION_TOKEN';

/**
 * Route d'arrivée d'un onglet de prise d'identité ouvert par le backoffice
 * (`/switchuser?code=…`). Un onglet qui démarre sur cette route ne demande
 * jamais la session des autres onglets.
 */
export const IMPERSONATION_LANDING_PATH = 'switchuser';

/** Profil de l'utilisateur courant mis en cache (voir UserSyncService). */
export const USER_CACHE_STORAGE_KEY = 'user';
